import { workbenchStore } from '../stores/workbench';
import { getHeadlessTemplateFiles } from '../templates/headlessTemplate';

/** Preview iframe ↔ host protocol (must stay in snapshot zip / editor / Chef context). */
export const HOT_EDIT_BRIDGE_REL_PATHS = [
  'src/ideoz/previewBridge.ts',
  'src/ideoz/previewBridgeTypes.ts',
] as const;

/**
 * Sorted union of headless template paths and workspace store paths (store wins on content).
 */
export function getMergedFilePaths(): string[] {
  const template = getHeadlessTemplateFiles();
  const store = workbenchStore.files.get();
  const set = new Set<string>([...Object.keys(template), ...Object.keys(store)]);
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}

/**
 * Resolved file body: live store entry overrides template defaults.
 */
export function getMergedFileContent(path: string): string {
  const fromStore = workbenchStore.files.get()[path];
  if (fromStore) return fromStore.content;
  return getHeadlessTemplateFiles()[path] ?? '';
}

/**
 * Copy template-only paths into the store so editor + sync behave uniformly.
 */
export function materializeTemplateFileIfNeeded(path: string): void {
  if (workbenchStore.files.get()[path]) return;
  const t = getHeadlessTemplateFiles()[path];
  if (t === undefined) return;
  workbenchStore.files.setKey(path, { content: t, modified: false });
  workbenchStore.recordToolWriteSnapshot(path, t);
}

/** Ensures bridge modules exist in the nanostore so snapshots, zip, and search treat them like user files. */
export function materializeHotEditBridgeFilesInStore(): void {
  for (const p of HOT_EDIT_BRIDGE_REL_PATHS) {
    materializeTemplateFileIfNeeded(p);
  }
}
